import axiosInstance from '../axiosInstance';

export const verifyPaymentStatus = async (orderId, studentId) => {
  try {
    const response = await axiosInstance.get('/students/payment-status', {
      params: {
        order_id: orderId,
        student_id: studentId
      }
    });
    return response.data;
  } catch (error) {
    throw {
      message: error.response?.data?.message || 'Failed to verify payment status',
      reason: error.response?.data?.reason,
      details: error.response?.data?.details || {},
      status: error.response?.status
    };
  }
};